import { DecisionMakerIcon, HouseIcon, PublicIcon } from '@change/ds-icons';
import type { Icon } from '@change/ds-icons';

type ReachOption = { name: 'global' | 'national' | 'local'; Icon: React.FC<Icon> };
export const REACH_OPTIONS: ReachOption[] = [
	{
		name: 'local',
		Icon: HouseIcon,
	},
	{
		name: 'national',
		Icon: DecisionMakerIcon,
	},
	{
		name: 'global',
		Icon: PublicIcon,
	},
];
